import React from 'react'
import MappingTabs from './MappingTabs'

const OmnitecTab = () => <MappingTabs />

export default OmnitecTab


// WEBPACK FOOTER //
// ./src/components/ChannelTabs/OmnitecTab/OmnitecTab.js